import React from "react";
import Select from "react-select";
interface ServiceSelectProps {
  title?: string;
  options: string[];
  disabled?: boolean;
  clearable?: boolean;
  selectedServices: string[];
  onChange: (services: string[]) => void;
}
const ServiceSelect: React.FC< ServiceSelectProps> = ({ title,
  options,
  onChange,
  disabled = false,
  clearable = false,
  selectedServices,
 }) => {
  return (
    <div
      className={`input-group-select relative w-full ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
    >
      <Select
        required
        isSearchable={false}
        isDisabled={disabled}
        isClearable={clearable}
        className="w-full bg-white border border-border focus:border-text-button text-subtitle-3 font-regular text-secondary-text whitespace-normal text-sm"
        defaultValue={selectedServices?.map((item: string) => ({
          value: item,
          label: item,
        }))}
        onChange={(e: any) => onChange([e.value])}
        options={options?.map((item: string) => ({ value: item, label: item }))}
        styles={{
          control: (provided) => ({
            ...provided,
            padding: "32px 0 0",
            boxShadow: "none",
            whiteSpace: "normal",
          }),
        }}
      />
      <label
        htmlFor="ServiceType"
        className={`text-subtitle-5 font-regular ${selectedServices ? "active" : "unactive"}`}
        style={{
          top: "5px",
          margin: "5px",
          padding: "0 5px",
          backgroundColor: !disabled ? "#fff" : "hsl(0, 0%, 95%)",
        }}
      >
        {title ?? "Select type of services you require*"}
      </label>
    </div>
  );
};
export default ServiceSelect;